import { Grid } from '../../../../Common/Grid'
import { Button, Input, Typography } from '@fullscreendigital/carrefour-dex-fe'
import { TitleHeader } from '../../../Common/TitleHeader'
import { useLocation, useNavigate } from 'react-router-dom'
import { useQuery } from 'react-query'
import { makeCorePostRequest } from '../../../../../../utils/api'
import { formatErrorMessage } from '../../../../../../utils/formatting'
import { useNotification } from '../../../../../../hooks'
import { useRef } from 'react'
import { CircularProgress } from '@mui/material'
import { useReactToPrint } from 'react-to-print'
import { PDFPrintDocument } from 'components/core-ui/PDFPrintDocument'

const Step5 = () => {
  const { showNotification } = useNotification()

  const location = useLocation()

  const navigate = useNavigate()

  const componentRef = useRef(null)

  const notice = location.state?.notice

  const fetchPdfBlob = async () => {
    return await makeCorePostRequest(
      '/shop-reception-mobile/truck/shop/exit/notice-as-pdf',
      {
        id: notice.id,
        noticeNumber: notice.code
      },
      {
        responseType: 'blob'
      }
    )
  }

  const { data: pdfBlob, isLoading: isLoadingPdf } = useQuery('pdfBlob', fetchPdfBlob, {
    onError: error => {
      showNotification({
        message: `Error while fetching pdf. ${formatErrorMessage(error)}`,
        type: 'error'
      })
    }
  })

  const handlePrint = useReactToPrint({
    content: () => componentRef.current
  })

  if (isLoadingPdf) {
    return <CircularProgress color="primary" style={{ margin: '40px auto' }} disableShrink />
  }

  return (
    <Grid
      gridContainerStyle={{ marginTop: '20px' }}
      maxWidth="xs"
      items={[
        <TitleHeader title="COMANDǍ CAMION RETUR" />,
        <Typography variant="medium" component="p" style={{ textAlign: 'center' }}>
          A fost generat avizul!
        </Typography>,
        <Input
          type="text"
          label="Număr aviz"
          variant="outlined"
          width="100%"
          value={notice?.code}
          readonly
        />,
        <Input
          type="text"
          label="Seria aviz"
          variant="outlined"
          width="100%"
          value={notice?.noticeSeries}
          readonly
        />,
        <Button
          type="button"
          variant="contained"
          label="PRINTEAZǍ"
          onClick={handlePrint}
          style={{ width: '100%' }}
          disabled={isLoadingPdf}
        />,
        <Button
          type="button"
          variant="contained"
          label="AM TERMINAT"
          onClick={() => navigate('/GoodsReturn')}
          style={{ width: '100%' }}
        />,
        <PDFPrintDocument pdfFile={pdfBlob} componentRef={componentRef} />
      ]}
      itemsPerRow={1}
    />
  )
}

export default Step5
